export const INSTANT_CHECKOUT_PAYMENT_UPDATE_SUCCESS = {
  message: 'Success! Payment method updated. ',
};

export const INSTANT_CHECKOUT_DELIVERY_ADDRESS_UPDATE_SUCCESS = {
  message: 'Success! Delivery address updated. ',
};

export const INSTANT_CHECKOUT_ENROLLMENT_SUCCESS = {
  message: "You're enrolled in Instant Checkout. ",
};

export const INSTANT_CHECKOUT_ADDRESS_UPDATE_SUCCESS = {
  message: 'Success! Delivery address updated. ',
};
